<template>
  <div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      size="mini"
      :validate-on-rule-change="false"
    >
      <el-row :gutter="10">
        <el-col :span="4">
          <el-form-item
            :label="
              $l('INDEX.form_label_production_order_goods_pattern') || '花型'
            "
            prop="goodsPattern"
          >
            <el-input
              v-model="formData.goodsPattern"
              :disabled="formalDisabled"
              clearable
              maxlength="50"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.form_label_color') || '颜色'"
            prop="colorCode"
          >
            <el-select
              v-model="formData.colorCode"
              collapse-tags
              size="mini"
              style="width:100%"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              clearable
              filterable
              :disabled="formalDisabled"
              @change="colorChange"
            >
              <el-option
                v-for="item in colorOptions"
                :key="item.value"
                :label="item.colorName"
                :value="item.value"
              >
                <span style="float: left">{{ item.colorName }}</span>
                <span
                  v-if="item.colorCard"
                  class="colorCard"
                  :style="{ background: item.colorCard }"
                >
                </span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.form_label_goodsColorCn') || '中文颜色'"
            prop="goodsColor"
          >
            <el-input
              v-model="formData.goodsColor"
              clearable
              maxlength="50"
              :disabled="formalDisabled"
              readonly
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.form_label_goodsColorEn') || '英文颜色'"
            prop="goodsColorEn"
          >
            <el-input
              v-model="formData.goodsColorEn"
              clearable
              maxlength="50"
              :disabled="formalDisabled"
              readonly
            >
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.form_sku_pack_size') || '售卖方式'"
            prop="skuPackSize"
          >
            <dict-select
              v-model="formData.skuPackSize"
              url="/master/common/dict/biz"
              :body="{ dictType: 'skuPackSize' }"
              :selectedLabel.sync="formData.skuPackSizeName"
              clearable
              filterable
              :disabled="formalDisabled"
              size="mini"
              style="width:100%"
            />
          </el-form-item>
        </el-col>

        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.eanCode') || 'EAN条码'"
            prop="eanCode"
          >
            <el-input
              v-model="formData.eanCode"
              clearable
              maxlength="50"
              :placeholder="$l('INDEX.tips_input_eanCode') || '请输入EAN条码'"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="16">
          <el-form-item
            :label="$l('INDEX.form_label_goodsSize') || '产品尺寸'"
            prop="goodsSize"
          >
            <el-input v-model="formData.goodsSize" readonly />
          </el-form-item>
        </el-col>

        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.form_label_goodsArea') || '产品面积(㎡)'"
            prop="goodsArea"
          >
            <el-input-number
              v-model="formData.goodsArea"
              :placeholder="
                $l('INDEX.form_placeholder_goodsArea') || '请输入产品面积'
              "
              controls-position="right"
              :step="1"
              :min="0"
              :precision="8"
              style="width:100%"
            >
            </el-input-number>
          </el-form-item>
        </el-col>

        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.form_label_design') || '企划人员'"
            prop="designCode"
          >
            <dict-select
              v-model="formData.designCode"
              url="/master/common/dict/baseUserSelect"
              :selectedLabel.sync="formData.designName"
              :disabled="formalDisabled"
              clearable
              filterable
              size="mini"
              style="width:100%"
            ></dict-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.form_label_englishSizeName') || '英文尺寸'"
            prop="englishSize"
          >
            <dict-select
              v-model="formData.englishSize"
              url="/master/common/dict/biz"
              :body="{ dictType: 'englishSize' }"
              clearable
              filterable
              size="mini"
              style="width:100%"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.form_label_ncNo') || 'NC产品编号'"
            prop="ncNo"
          >
            <el-input v-model="formData.ncNo" clearable readonly> </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item
            :label="$l('INDEX.form_label_Factory_Default') || '成品工厂(默认)'"
            prop="scmCode"
          >
            <el-input v-model="formData.scmName" clearable readonly />
          </el-form-item>
        </el-col>

        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.form_label_ftyPrice') || '工厂单价(rmb)'"
            prop="ftyPrice"
          >
            <el-input v-model="formData.ftyPrice" clearable readonly />
          </el-form-item>
        </el-col>

        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.form_label_buyer') || '采购人员'"
            prop="buyerCode"
          >
            <el-input v-model="formData.buyerName" clearable readonly />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item
            :label="$l('INDEX.form_label_materialInfo') || '材料信息'"
            prop="materialInfo"
          >
            <el-input
              v-model="formData.materialInfo"
              :placeholder="materialInfoData.p_materialInfo"
              type="textarea"
              clearable
              show-word-limit
              :rows="4"
              :maxlength="1000"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('INDEX.form_label_materialInfoEn') || '英文材料信息'"
            prop="materialInfoEn"
          >
            <el-input
              v-model="formData.materialInfoEn"
              :placeholder="materialInfoData.p_materialInfoEn"
              type="textarea"
              clearable
              show-word-limit
              :rows="4"
              :maxlength="1000"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="3">
          <el-form-item
            :label="$l('INDEX.form_label_goodsProperties') || '产品属性'"
            prop="goodsProperties"
          >
            <dict-select
              v-model="formData.goodsProperties"
              url="/master/common/dict/biz"
              :body="{ dictType: 'goodsProperties' }"
              :selectedLabel.sync="formData.goodsProperties"
              clearable
              size="mini"
              style="width:100%"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="9">
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item
                :label="$l('INDEX.form_label_unitLength') || '单品包装长(cm)'"
                prop="unitLength"
              >
                <el-input-number
                  v-model="formData.unitLength"
                  controls-position="right"
                  :step="1"
                  :min="0"
                  :precision="2"
                  style="width:100%"
                  v-el-inputnumber-default0
                >
                </el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="$l('INDEX.form_label_unitWidth') || '单品包装宽(cm)'"
                prop="unitWidth"
              >
                <el-input-number
                  v-model="formData.unitWidth"
                  controls-position="right"
                  :step="1"
                  :min="0"
                  :precision="2"
                  style="width:100%"
                  v-el-inputnumber-default0
                >
                </el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="$l('INDEX.form_label_unitHeight') || '单品包装高(cm)'"
                prop="unitHeight"
              >
                <el-input-number
                  v-model="formData.unitHeight"
                  controls-position="right"
                  :step="1"
                  :min="0"
                  :precision="2"
                  style="width:100%"
                  v-el-inputnumber-default0
                >
                </el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.form_label_goodsWeight') || '单品重量(kg)'"
            prop="goodsWeight"
          >
            <el-input-number
              v-model="formData.goodsWeight"
              controls-position="right"
              :step="1"
              :min="0"
              :precision="3"
              style="width:100%"
              v-el-inputnumber-default0
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.form_label_unitWeight') || '单品包装重量(kg)'"
            prop="unitWeight"
          >
            <el-input-number
              v-model="formData.unitWeight"
              controls-position="right"
              :step="1"
              :min="0"
              :precision="3"
              style="width:100%"
              @change="changeCtnGrossWeight"
              v-el-inputnumber-default0
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.form_label_unitCbm') || '单品包装体积(m³)'"
            prop="unitCbm"
          >
            <el-input v-model="unitCbm" controls-position="right" readonly>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="9" :offset="3">
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item
                :label="
                  $l('INDEX.form_label_unitLength_read') || '单品包装长(英寸)'
                "
              >
                <el-input
                  v-model="unitLengthRead"
                  controls-position="right"
                  readonly
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="
                  $l('INDEX.form_label_unitWidth_read') || '单品包装宽(英寸)'
                "
              >
                <el-input
                  v-model="unitWidthRead"
                  controls-position="right"
                  readonly
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="
                  $l('INDEX.form_label_unitHeight_read') || '单品包装高(英寸)'
                "
              >
                <el-input
                  v-model="unitHeightRead"
                  controls-position="right"
                  readonly
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.form_label_goodsWeight_read') || '单品重量(磅)'"
          >
            <el-input
              v-model="goodsWeightRead"
              controls-position="right"
              readonly
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="
              $l('INDEX.form_label_unitWeight_read') || '单品包装重量(磅)'
            "
          >
            <el-input
              v-model="unitWeightRead"
              controls-position="right"
              readonly
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="
              $l('INDEX.form_label_unitCbm_read') || '单品包装体积(英尺³)'
            "
          >
            <el-input
              v-model="unitCbmRead"
              controls-position="right"
              readonly
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="3">
          <el-form-item
            :label="$l('INDEX.form_label_inCtnQty') || '装箱入数'"
            prop="inCtnQty"
          >
            <el-input-number
              v-model="formData.inCtnQty"
              controls-position="right"
              :step="1"
              :min="0"
              :precision="0"
              style="width:100%"
              @change="changeCtnGrossWeight"
              v-el-inputnumber-default0
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="9">
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item
                :label="$l('INDEX.form_label_ctnLength') || '纸箱长(cm)'"
                prop="ctnLength"
              >
                <el-input-number
                  v-model="formData.ctnLength"
                  controls-position="right"
                  :step="1"
                  :min="0"
                  :precision="2"
                  style="width:100%"
                  v-el-inputnumber-default0
                >
                </el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="$l('INDEX.form_label_ctnWidth') || '纸箱宽(cm)'"
                prop="ctnWidth"
              >
                <el-input-number
                  v-model="formData.ctnWidth"
                  controls-position="right"
                  :step="1"
                  :min="0"
                  :precision="2"
                  style="width:100%"
                  v-el-inputnumber-default0
                >
                </el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="$l('INDEX.form_label_ctnHeight') || '纸箱高(cm)'"
                prop="ctnHeight"
              >
                <el-input-number
                  v-model="formData.ctnHeight"
                  controls-position="right"
                  :step="1"
                  :min="0"
                  :precision="2"
                  style="width:100%"
                  v-el-inputnumber-default0
                >
                </el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.form_label_ctnNetWeight') || '箱净重(kg)'"
          >
            <el-input-number
              v-model="ctnNetWeightKgRead"
              controls-position="right"
              :step="1"
              :min="0"
              :precision="3"
              style="width:100%"
              v-el-inputnumber-default0
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.form_label_ctnGrossWeight') || '箱毛重(kg)'"
          >
            <el-input-number
              v-model="ctnGrossWeightKgRead"
              controls-position="right"
              :step="1"
              :min="0"
              :precision="3"
              style="width:100%"
              v-el-inputnumber-default0
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.form_label_ctnCbm') || '纸箱体积(m³)'"
          >
            <el-input v-model="ctnCbm" controls-position="right" readonly />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="9" :offset="3">
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item
                :label="$l('INDEX.form_label_ctnLength_read') || '纸箱长(英寸)'"
              >
                <el-input
                  v-model="ctnLengthRead"
                  controls-position="right"
                  readonly
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="$l('INDEX.form_label_ctnWidth_read') || '纸箱宽(英寸)'"
              >
                <el-input
                  v-model="ctnWidthRead"
                  controls-position="right"
                  readonly
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="$l('INDEX.form_label_ctnHeight_read') || '纸箱高(英寸)'"
              >
                <el-input
                  v-model="ctnHeightRead"
                  controls-position="right"
                  readonly
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.form_label_boxNetWeight_read') || '箱净重(磅)'"
          >
            <el-input
              v-model="ctnNetWeightRead"
              controls-position="right"
              readonly
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.form_label_ctnGrossWeight_read') || '箱毛重(磅)'"
          >
            <el-input
              v-model="ctnGrossWeightRead"
              controls-position="right"
              readonly
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.form_label_ctnCbm_read') || '纸箱体积(英尺³)'"
          >
            <el-input v-model="ctnCbmRead" controls-position="right" readonly />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.form_label_hscodeCn') || '中国HSCODE'"
          >
            <el-input
              v-model="formData.hscodeCn"
              :placeholder="
                $l('INDEX.form_placeholder_hscodeCn') || '请输入中国HSCODE'
              "
              clearable
              maxlength="50"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.form_label_hscodeNameCn') || '报关中文品名'"
          >
            <el-input
              v-model="formData.hscodeName"
              :placeholder="
                $l('INDEX.form_placeholder_hscodeNameCn') ||
                  '请输入报关中文品名'
              "
              clearable
              maxlength="50"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.form_label_hscodeNameEn') || '报关英文品名'"
          >
            <el-input
              v-model="formData.hscodeNameEn"
              :placeholder="
                $l('INDEX.form_placeholder_hscodeNameEn') ||
                  '请输入报关英文品名'
              "
              clearable
              maxlength="50"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.form_label_needInspection') || '是否商检'"
          >
            <el-select
              v-model="formData.needInspection"
              placeholder="请选择"
              size="mini"
              style="width:100%"
            >
              <el-option
                v-for="item in needInspectionOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.form_label_customsPrice') || '报关单价'"
          >
            <el-input-number
              v-model="formData.customsPrice"
              :placeholder="
                $l('INDEX.form_placeholder_customsPrice') || '请输入报关单价'
              "
              controls-position="right"
              :step="1"
              :min="0"
              :precision="4"
              style="width:100%"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.form_label_taxRefundCn') || '中国退税'"
          >
            <el-input-number
              v-model="formData.taxRefundCn"
              :placeholder="
                $l('INDEX.form_placeholder_taxRefundCn') || '请输入中国退税'
              "
              controls-position="right"
              :step="1"
              :min="0"
              :precision="4"
              style="width:100%"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.form_label_ctnSkuNo') || '纸箱SKU(外箱印刷)'"
          >
            <el-input
              v-model="formData.ctnSkuNo"
              :placeholder="
                $l('INDEX.form_placeholder_ctnSkuNo') ||
                  '请输入纸箱SKU(外箱印刷)'
              "
              clearable
              maxlength="50"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.form_label_originalPlace') || '境内货源地'"
          >
            <el-input
              v-model="formData.originalPlace"
              :placeholder="
                $l('INDEX.form_placeholder_originalPlace') || '请输入境内货源地'
              "
              clearable
              maxlength="50"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item
            :label="$l('INDEX.form_label_declarationElements') || '申报要素'"
          >
            <el-input
              v-model="formData.declarationElements"
              :placeholder="
                $l('INDEX.form_placeholder_declarationElements') ||
                  '请输入申报要素'
              "
              clearable
              type="textarea"
              :rows="3"
              maxlength="1000"
              show-word-limit
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import {
  multiply,
  multiplyRound,
  divideRound,
  add,
} from '@/libs/util.number.js'
import { request } from '@/api/service'

export default {
  mixins: [EditLoading],
  props: {
    amzSkuCode: { type: String, default: '' },
    disabled: { type: Boolean, default: true },
    isCopy: { type: Boolean, default: false },
    isSpuCopy: { type: Boolean, default: false },
    amzSkuStatus: { type: String, default: '' },
    amzSpuCode: { type: String, default: '' },
    form: { type: Object, default: () => {} },
  },
  data() {
    return {
      formData: {
        colorCode: '',
        goodsColorEn: '',
        goodsColor: '',
        goodsName: '',
        goodsNameEn: '',
        designCode: '',
        designName: '',
        isVc: '',
        amzSkuSpecList: [],
      },
      materialInfoData: {
        p_materialInfo: '',
        p_materialInfoEn: '',
      },
      salesPersonCode: '',
      salesPersonName: '',
      formalDisabled: false,
      masterCategoryParams: { parentCode: 'ABSHome' },
      categoryTree: [],
      colorOptions: [],
      needInspectionOptions: [
        {
          value: 'Y',
          label: '是',
        },
        {
          value: 'N',
          label: '否',
        },
      ],
      ctnGrossWeightKgRead: 0,
      ctnNetWeightKgRead: 0,
    }
  },
  watch: {
    form: {
      handler(val) {
        if (val) {
          this.formData.spuGoodsName = val.goodsName
          this.formData.spuGoodsNameEn = val.goodsNameEn
          this.formData.goodsName = val.goodsName
          this.formData.goodsNameEn = val.goodsNameEn
          this.formData.brandCode = val.brandCode
          this.formData.brandName = val.brandName
          this.formData.collectionNo = val.collectionNo
          this.formData.collectionName = val.collectionName
          this.formData.collectionNameCn = val.collectionNameCn
          this.formData.masterCategoryName = val.masterCategoryName
          this.formData.masterCategoryCode = val.masterCategoryCode
          this.formData.detailCategoryCode = val.categoryCode
          this.formData.detailCategoryName = val.categoryName
          this.formData.categoryFullName = val.categoryFullName
          this.formData.designCode = val.designCode
          this.formData.designName = val.designName
          this.formData.isVc = val.isVc
          this.formData.amzSkuSpecList = []
          this.formData.v_isVc = val.isVc == 'Y' ? 'VC' : '否'
        }
      },
      immediate: true,
    },
  },
  computed: {
    detailCategoryParams() {
      return { parentCode: this.formData.masterCategoryCode || 'x' }
    },
    unitCbm() {
      const { unitLength, unitWidth, unitHeight } = this.formData
      return divideRound(
        multiply(multiply(unitLength, unitWidth), unitHeight),
        1000000,
        8
      )
    },
    ctnCbm() {
      const { ctnLength, ctnWidth, ctnHeight } = this.formData
      return divideRound(
        multiply(multiply(ctnLength, ctnWidth), ctnHeight),
        1000000,
        8
      )
    },
    unitLengthRead() {
      return divideRound(this.formData.unitLength, 2.54, 7)
    },
    unitWidthRead() {
      return divideRound(this.formData.unitWidth, 2.54, 7)
    },
    unitHeightRead() {
      return divideRound(this.formData.unitHeight, 2.54, 7)
    },
    goodsWeightRead() {
      return multiplyRound(this.formData.goodsWeight, 2.20462262185, 7)
    },
    unitWeightRead() {
      return multiplyRound(this.formData.unitWeight, 2.20462262185, 7)
    },
    unitCbmRead() {
      return multiplyRound(this.unitCbm, 35.3147248, 7)
    },
    ctnLengthRead() {
      return divideRound(this.formData.ctnLength, 2.54, 7)
    },
    ctnWidthRead() {
      return divideRound(this.formData.ctnWidth, 2.54, 7)
    },
    ctnHeightRead() {
      return divideRound(this.formData.ctnHeight, 2.54, 7)
    },
    ctnNetWeightRead() {
      return multiplyRound(this.ctnNetWeightKgRead, 2.20462262185, 7)
    },
    ctnGrossWeightRead() {
      return multiplyRound(this.ctnGrossWeightKgRead, 2.20462262185, 7)
    },
    // ctnNetWeightKgRead() {
    //   return multiplyRound(this.formData.unitWeight, this.formData.inCtnQty, 3)
    // },
    ctnCbmRead() {
      return multiplyRound(this.ctnCbm, 35.3147248, 7)
    },
    required() {
      return !this.amzSpuCode
    },
    isSingle() {
      return 'single' == this.formData.skuPackSize
    },
    rules() {
      return {
        goodsName: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_goodsNameCn') || '请输入中文名称',
            trigger: 'blur',
          },
        ],
        goodsNameEn: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_goodsNameEn') || '请输入英文名称',
            trigger: 'blur',
          },
        ],
        brandCode: [
          {
            required: true,
            message: this.$l('INDEX.form_placeholder_brand') || '请选择品牌',
            trigger: 'blur',
          },
        ],
        skuPackSize: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_sellTypes') || '请选择售卖方式',
            trigger: 'blur',
          },
        ],
        detailCategoryCode: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_masterCategory') || '请选择品类',
            trigger: ' change',
          },
        ],
        goodsColor: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_goodsColorCn') ||
              '请输入中文颜色',
            trigger: 'blur',
          },
        ],
        goodsColorEn: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_goodsColorEn') ||
              '请输入英文颜色',
            trigger: 'blur',
          },
        ],
        goodsPattern: [
          {
            required: true,
            message:
              this.$l('INDEX.tips_goods_label_orderGoodsPattern') ||
              '请输入花型',
            trigger: 'blur',
          },
        ],
        colorCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        isVc: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        eanCode: [
          {
            required: this.formData.isVc == 'Y',
            message: this.$l('INDEX.tips_input_eanCode') || '请输入EAN条码',
            trigger: 'change',
          },
        ],
        designCode: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_design') || '请选择企划人员',
            trigger: 'change',
          },
        ],
        englishSize: [
          {
            required: true,
            message: '请选择英文尺寸',
            trigger: 'change',
          },
        ],
        materialInfo: [
          {
            required: this.required,
            message:
              this.$l('INDEX.form_placeholder_materialInfo') ||
              '请输入材料信息',
            trigger: 'blur',
          },
        ],
        materialInfoEn: [
          {
            required: this.required,
            message:
              this.$l('INDEX.form_placeholder_materialInfoEn') ||
              '请输入英文材料信息',
            trigger: 'blur',
          },
        ],
        goodsProperties: [
          {
            required: this.required,
            message:
              this.$l('INDEX.form_placeholder_goodsProperties') ||
              '请输入产品属性',
            trigger: 'blur',
          },
        ],
        unitLength: [
          {
            required: this.required,
            message:
              this.$l('INDEX.form_placeholder_unitLength') ||
              '请输入单品包装长',
            trigger: 'blur',
          },
        ],
        unitWidth: [
          {
            required: this.required,
            message:
              this.$l('INDEX.form_placeholder_unitWidth') || '请输入单品包装宽',
            trigger: 'blur',
          },
        ],
        unitHeight: [
          {
            required: this.required,
            message:
              this.$l('INDEX.form_placeholder_unitHeight') ||
              '请输入单品包装高',
            trigger: 'blur',
          },
        ],
        goodsWeight: [
          {
            required: this.required,
            message:
              this.$l('INDEX.form_placeholder_goodsWeight') || '请输入单品重量',
            trigger: 'blur',
          },
        ],
        unitWeight: [
          {
            required: this.required,
            message:
              this.$l('INDEX.form_placeholder_unitWeight') ||
              '请输入单品包装重量',
            trigger: 'blur',
          },
        ],
        inCtnQty: [
          {
            required: this.required,
            message:
              this.$l('INDEX.form_placeholder_inCtnQty') || '请输入装箱入数',
            trigger: 'blur',
          },
        ],
        ctnLength: [
          {
            required: this.required,
            message:
              this.$l('INDEX.form_placeholder_ctnLength') || '请输入纸箱长',
            trigger: 'blur',
          },
        ],
        ctnWidth: [
          {
            required: this.required,
            message:
              this.$l('INDEX.form_placeholder_ctnWidth') || '请输入纸箱宽',
            trigger: 'blur',
          },
        ],
        ctnHeight: [
          {
            required: this.required,
            message:
              this.$l('INDEX.form_placeholder_ctnHeight') || '请输入纸箱高',
            trigger: 'blur',
          },
        ],
        ctnNetWeight: [
          {
            required: this.required,
            message:
              this.$l('INDEX.form_placeholder_ctnNetWeight') || '请输入箱净重',
            trigger: 'blur',
          },
        ],
        ctnGrossWeight: [
          {
            required: this.required,
            message:
              this.$l('INDEX.form_placeholder_ctnGrossWeight') ||
              '请输入箱毛重',
            trigger: 'blur',
          },
        ],
      }
    },
  },
  mounted() {
    this.getData()
    this.getTreeData()
    this.getColor()
  },
  methods: {
    ...mapActions('admin/page', ['close']),
    async goodsStandard() {
      if (!this.formData.detailCategoryCode) return
      const res = await this.$api.masterGoodsInputStandardCategoryDetailApi({
        categoryCode: this.formData.detailCategoryCode,
      })
      if (!res) return
      this.materialInfoData.p_materialInfo = res.body.materialInfo
      this.materialInfoData.p_materialInfoEn = res.body.materialInfoEn
    },
    async getData() {
      if (this.amzSkuCode) {
        let res = undefined
        if (this.isCopy || this.isSpuCopy) {
          res = await this.$api
            .ecomAmzSkuCopyApi({ amzSkuCode: this.amzSkuCode })
            .catch(() => null)
        } else {
          res = await this.$api
            .ecomAmzSkuDetailApi({ amzSkuCode: this.amzSkuCode })
            .catch(() => null)
        }
        if (!res) return
        const data = res.body || {}
        this.formData = data
        this.ctnGrossWeightKgRead = this.formData.ctnGrossWeight
        this.ctnNetWeightKgRead = this.formData.ctnNetWeight
        this.formalDisabled =
          this.formData.amzSkuStatus == 'Y' ||
          this.formData.amzSkuStatus == 'P' ||
          (this.formData.amzSkuStatus == 'C' &&
            this.formData.applicationStatus == 'O')
        this.$emit('update:amzSkuStatus', data.amzSkuStatus || '')
        await this.goodsStandard()
      } else {
        await this.goodsStandard()
      }
    },
    getTreeData() {
      this.$api
        .ecomAmzSpuCategoryApi(this.masterCategoryParams)
        .then((res) => {
          this.categoryTree = res.body.data || []
        })
        .catch(() => {})
    },
    onCategoryChange() {
      const nodes = this.$refs.cascaderCategoryTreeRef.getCheckedNodes()
      if (nodes?.length && nodes[0] && nodes[0].path?.length) {
        this.formData.displayCategoryCode = nodes[0].path.join(',')
        this.formData.masterCategoryCode = nodes[0].path[0]
      } else {
        this.formData.displayCategoryCode = null
        this.formData.masterCategoryCode = null
      }
    },
    getColor() {
      request({
        url: '/ecom/amz/sku/dict/color',
        method: 'post',
        data: { isCustomer: 'N' },
      }).then((res) => {
        this.colorOptions = res.body.data
      })
    },
    async reloadSku() {
      if (!this.amzSkuCode) return
      const res = await this.$api
        .ecomAmzSkuDetailApi({ amzSkuCode: this.amzSkuCode })
        .catch(() => null)
      if (!res) return
      const data = res.body || {}
      const { scmCode, scmName, ncNo, ftyPrice, buyerCode, buyerName } = data
      this.formData.scmCode = scmCode
      this.formData.scmName = scmName
      this.formData.buyerCode = buyerCode
      this.formData.buyerName = buyerName
      this.formData.ncNo = ncNo
      this.formData.ftyPrice = ftyPrice
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return
      if (this.ctnNetWeightKgRead > this.ctnGrossWeightKgRead) {
        this.$message.error('箱净重不可大于箱毛重')
        return
      }
      this.loadingOpen()
      const res = await this.saveApi()
      this.loadingClose()
      if (!res) return
      const { status, body } = res || {}
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })
      if ((!this.amzSkuCode && !this.amzSpuCode) || this.isCopy) {
        // await this.closeCurPage()
        this.$router.replace({
          name: 'ecom-base-awsGoods-detail',
          params: { code: body, pageType: 'edit' },
          query: { amzSkuNo: this.formData.amzSkuNo },
        })
        return
      }
      this.$emit('update:amzSkuCode', body || '')
      this.$emit('update:isSpuCopy', false)
      setTimeout(() => {
        this.getData()
        this.$emit('reload')
      }, 0)
    },
    saveApi() {
      const params = {
        ...this.formData,
        unitCbm: this.unitCbm,
        ctnCbm: this.ctnCbm,
        ctnNetWeight: this.ctnNetWeightKgRead,
        ctnGrossWeight: this.ctnGrossWeightKgRead,
        amzSpuCode: this.amzSpuCode || this.formData.amzSpuCode,
      }

      let goodsName = params.spuGoodsName
      let goodsNameEn = params.spuGoodsNameEn
      if (!this.formalDisabled && !!goodsName && !!goodsNameEn) {
        if (this.isSingle) {
          goodsName = [goodsName, params.goodsColor, params.goodsSize]
            .filter(Boolean)
            .join('')
          goodsNameEn = [goodsNameEn, params.goodsColorEn, params.goodsSize]
            .filter(Boolean)
            .join(' ')
        } else {
          goodsName = [goodsName, params.skuPackSizeName, params.goodsColor]
            .filter(Boolean)
            .join('')
          goodsNameEn = [goodsNameEn, params.skuPackSize, params.goodsColorEn]
            .filter(Boolean)
            .join(' ')
        }

        params.goodsName = goodsName
        params.goodsNameEn = goodsNameEn
      }

      if ((this.amzSpuCode && !this.amzSkuCode) || this.isSpuCopy) {
        return this.$api.ecomAmzSpuAddSkuApi(params).catch(() => null)
      } else {
        return this.$api.ecomAmzSkuSaveApi(params).catch(() => null)
      }
    },
    async colorChange(code) {
      if (!code) return
      const res = await request({
        url: '/ecom/amz/sku/dict/color/detail',
        method: 'POST',
        data: { colorCode: code },
      }).catch(() => null)
      if (!res) return
      const { colorName, colorNameEn } = res.body
      this.formData.goodsColor = colorName
      this.formData.goodsColorEn = colorNameEn
    },
    changeCtnGrossWeight() {
      this.ctnNetWeightKgRead = multiplyRound(
        this.formData.unitWeight,
        this.formData.inCtnQty,
        3
      )
      this.ctnGrossWeightKgRead = add(this.ctnNetWeightKgRead, 1)
    },
    async closeCurPage() {
      // 关闭当前页面
      await this.close({
        tagName: this.$route.fullPath,
        showConfirm: false,
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
.side-frame-warning {
  padding: 1px 5px;
  border-left: 3px solid $color-warning;
  height: 20px;
  margin-top: 3px;
}
.colorCard {
  float: right;
  margin: 3px 0px 0px 5px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 30px;
  width: 60px;
  color: #ffffff;
}

.side-frame-success {
  padding: 2px 10px;
  border-left: 3px solid $color-success;
  margin: 0;
}
.border-detail-main-form {
  margin-top: -1px;
}
</style>
